export default __webpack_public_path__ + "static/media/five.cc2f531e.svg";